module.exports = __webpack_public_path__ + "static/media/EzioAuditore.d5849bae.jpg";